import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core'
import { StateService } from '../../services/state.service'
import { Article } from '../../models/article'
import { RouterLink } from '@angular/router'
import { NgOptimizedImage } from '@angular/common'
import {
  IonButtons,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonMenuButton,
  IonRouterLink,
  IonRow,
  IonToolbar,
} from '@ionic/angular'

@Component({
  selector: 'app-home',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    IonButtons,
    IonHeader,
    IonToolbar,
    IonMenuButton,
    IonContent,
    IonGrid,
    IonCol,
    IonRow,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonRouterLink,
    NgOptimizedImage,
  ],
})
export class HomePageComponent {
  private stateService = inject(StateService)

  readonly articles: Signal<Article[]>
  readonly frontPageIntro: Signal<string>

  readonly logoImage = computed(() => {
    const language = this.stateService.currentLanguage()
    return language === 'da' || language === 'sv'
      ? 'images/logo-gravidmeddiabetes.png'
      : 'images/logo-pregnantwithdiabetes.png'
  })

  constructor() {
    const stateService = this.stateService

    this.articles = stateService.allArticlesSorted
    this.frontPageIntro = stateService.frontPageIntro
  }
}
